export const isMobileDevice = () => {
  const hasCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
  const isNarrowViewport = window.innerWidth < 768;
  const isMobileUA = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  return hasCoarsePointer || (isNarrowViewport && isMobileUA);
};

export const supportsCamera = () => {
  return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
};

export const isMac = () => /Mac|iPhone|iPad|iPod/i.test(navigator.platform || navigator.userAgent);
